var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInviteFriends = function SvgInviteFriends(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#invite_friends_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.561 16.68c-.097 1.006-.879 1.753-1.887 1.837-1.337.113-3.517.234-6.674.234s-5.337-.122-6.674-.234c-1.008-.084-1.79-.83-1.887-1.837-.098-1.01-.189-2.513-.189-4.595s.092-3.585.189-4.595c.097-1.007.879-1.754 1.887-1.838C4.663 5.54 6.843 5.418 10 5.418s5.338.122 6.674.234c1.008.084 1.79.831 1.887 1.838.098 1.01.189 2.512.189 4.595s-.092 3.585-.189 4.594M10 5.418v13.333M1.25 12.082h17.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.003 5.417c0-1.25-1.667-4.167-4.167-4.167-1.458 0-2.5 1.12-2.5 2.5 0 .7.288 1.335.753 1.788"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 5.417c0-1.25 1.667-4.167 4.167-4.167 1.458 0 2.5 1.12 2.5 2.5a2.5 2.5 0 0 1-.754 1.788"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "invite_friends_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgInviteFriends;